/** @typedef {import('@/types/api').Appointment} Appointment */

/**
 * @param {string} iso
 */
export function formatPosAppointmentTime(iso) {
  const date = new Date(iso)
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function posAppointmentGuestLabel(appointment) {
  return appointment.customer?.name ?? 'Guest'
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function posAppointmentServiceLabel(appointment) {
  const names = (appointment.services ?? [])
    .map((line) => line.service?.name)
    .filter(Boolean)

  return names.length > 0 ? names.join(', ') : 'Service'
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function posAppointmentSummary(appointment) {
  const stylist = appointment.stylist?.name ?? appointment.services?.[0]?.stylist?.name
  const time = formatPosAppointmentTime(appointment.starts_at)

  return stylist ? `${time} · ${stylist}` : time
}
